import {
  FilmSessionFragment,
  FilmTileFragment,
  FilmTileWithSessionsFragment,
  SessionTicketsFragment,
} from "@generated-types"
import dayjs from "dayjs"

export function isPastEvent(args: {
  film?: FilmTileFragment | FilmTileWithSessionsFragment
  session?: FilmSessionFragment | SessionTicketsFragment | null
}): boolean {
  const now = dayjs().subtract(15, "minute")
  if (args.session?.info?.dateTime) {
    if (dayjs(args.session?.info?.dateTime).isBefore(now)) {
      return true
    }
  } else if (args.film?.sessions?.length) {
    if (
      args.film.sessions.every((session) => {
        return dayjs(session?.info?.dateTime).isBefore(now)
      })
    ) {
      return true
    }
  }
  return false
}
